var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1E81F7",
    width: "40px",
    height: "40px",
    viewBox: "-0.5 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.095 13.221c-.674 0-1.22-.546-1.22-1.22 0-.674.546-1.22 1.22-1.22.674 0 1.22.546 1.22 1.22 0 .674-.546 1.22-1.22 1.22zm8.028-5.124c-1.731 1.473-3.041 2.684-5.262 3.377-.166-.836-.684-1.525-1.389-1.92l-.014-.007c.866-2.231 1.464-5.216.994-6.625-.698-2.095-2.967-3.765-7.332-2.469-4.789 1.423-5.233 5.545-2.419 6.546 2.144.763 3.852 1.291 5.563 2.874-.604.515-.984 1.276-.987 2.126 0 .016.005.031.005.047-2.364.367-5.242 1.341-6.226 2.451-1.464 1.652-1.778 4.452 1.528 7.584 3.626 3.435 7.418 1.759 6.878-1.178-.412-2.239-.809-3.982-.293-6.254.275.103.593.165.925.168h.002c.534-.001 1.033-.152 1.457-.414l-.012.007c1.499 1.864 3.784 3.874 5.238 4.171 2.164.443 4.745-.686 5.804-5.115 1.162-4.859-2.186-7.305-4.459-5.369z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropeller);
export default __webpack_public_path__ + "static/media/propeller.d85cf94643bec414ef77792136d53e37.svg";
export { ForwardRef as ReactComponent };